import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

export interface LoadTestsNames {
  type: 'LoadTestsNames'
  [startFetch]: string
}

export interface LoadTestsNamesSuccess {
  type: 'LoadTestsNamesSuccess'
  testsNames: string[]
  [stopFetch]: string
}

export interface LoadTestsNamesFailed {
  type: 'LoadTestsNamesFailed'
  [stopFetch]: string
}

export const testsNamesActions = unionize({
  ...ofType<LoadTestsNames>('LoadTestsNames'),
  ...ofType<LoadTestsNamesSuccess>('LoadTestsNamesSuccess'),
  ...ofType<LoadTestsNamesFailed>('LoadTestsNamesFailed')
})

export type TestsNamesActions = UnionOf<typeof testsNamesActions>



// WEBPACK FOOTER //
// ./src/tests-components/select-tests-names/testsNames.actions.ts